import axios from 'axios';
import { normalizeJSONAPIResponse } from 'utils/modelUtils';

export const updateDocument = async (file: File) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await axios.post('/api/v3/documents', formData);
  return normalizeJSONAPIResponse(response.data);
};
